module.exports = __webpack_public_path__ + "img/hb-back.f1141aac.png";